<section class="tw-w-full">
  <mat-form-field
    appearance="outline"
    class="tw-w-full"
    (click)="fileInput.click()"
  >
    <mat-label>
      {{ input_label | translate }}
    </mat-label>
    <input
      matInput
      type="text"
      readonly
      [value]="file?.name || ''"
      [formControl]="input_formControlName"
      class="input-file tw-relative"
    />
    <input
      type="file"
      multiple
      hidden
      #fileInput
      [value]="file"
      [accept]="input_fileAccept"
      [placeholder]="input_placeholder | translate"
      (input)="onCheckFile($event)"
    />
    <div
      ngxMatFileInputIcon
      *ngIf="isEmptyFile && !loading"
      [matTooltip]="'common.selectFile' | translate"
      mat-icon-button
      matSuffix
      class="select-file-icon tw-ml-[10px] ltr:tw-mr-[10px]"
    >
      <a class="tw-flex-center">
        <i
          class="mdi mdi-folder mdi-22px tw-text-gray-900 dark:tw-text-white"
          after-label
        ></i>
      </a>
    </div>
    <div
      ngxMatFileInputIcon
      *ngIf="!loading"
      mat-icon-button
      matSuffix
      [class.d-none]="isEmptyFile"
      (click)="clearFile()"
    >
      <mat-icon
        class="tw-ml-[10px] ltr:tw-mr-[10px] dark:tw-text-gray-400"
        [matTooltip]="'common.deleteSelectedFile' | translate"
        >clear</mat-icon
      >
    </div>
    <mat-icon
      ngxMatFileInputIcon
      *ngIf="loading"
      class="text-primary"
      matSuffix
    >
      <span
        class="spinner-border spinner-border-sm text-primary tw-mb-2"
        role="status"
        aria-hidden="true"
      ></span>
      <span class="sr-only">Loading...</span>
    </mat-icon>
  </mat-form-field>
</section>

<div class="progress tw-h-[20px] tw-mb-5" *ngIf="input_progress">
  <div class="progress-bar" [style.width]="input_progress + '%'">
    {{ input_progress }}%
  </div>
</div>
